import { useQuery } from "react-query";
import { GraphQLAttachmentRecordDAOFactory } from "../../../../lib/attachment/record/graphql/GraphQLAttachmentRecordDAOFactory";
import { Storage } from "aws-amplify";
import { ImageSource } from "../../../../API";
import { ImageEntity } from "../../../../lib/dashboard/types/ImageEntity";
import ImageVariant from "../../../../lib/attachment/ImageVariant";
import { Attachment } from "../../../../models";
import { ListResponse } from "../../../../lib/util/data/list/ListResponse";

const attachmentDAO = GraphQLAttachmentRecordDAOFactory.getInstance();
export const IMAGE_QUERY_KEY = 'images';

export const useImagesByPropertyId = (propertyId: string) => {
    return useQuery(
        [IMAGE_QUERY_KEY, 'property', propertyId],
        async () => {
            let allImages: Array<Attachment> = [];
            let nextToken = undefined;
            do {
                const attachments: ListResponse<Attachment> = await attachmentDAO.listByPropertyId(propertyId, nextToken);
                allImages = [...allImages, ...attachments.items];
                nextToken = attachments.nextToken;
            } while (nextToken);
            return (await (Promise.all(allImages.map(async attachment => {
                try {
                    if (!attachment || !attachment.key || attachment.type == 'VIDEO') {
                        return;
                    }
                    // uses download: true to check if file exists, workaround for amplify v4
                    const thumbnailData: any = await Storage.get(
                        `${attachment.key}${ImageVariant.THUMBNAIL}`,
                        {
                            download: true
                        },
                    ).catch((error) => {
                        return undefined;
                    });

                    const thumbnail = thumbnailData ? URL.createObjectURL(thumbnailData.Body) : undefined;
                    return {
                        key: attachment.key,
                        parentId: attachment.parentId,
                        urls: {
                            original: await Storage.get(
                                attachment.key!
                            ),
                            thumbnail
                        },
                        source: attachment.imageSource as ImageSource
                    } satisfies ImageEntity;
                } catch (error) {
                    return;
                }
            }))));
        },
        {
            enabled: !!propertyId,
            keepPreviousData: true
        }
    );
};
